import { useNavigate } from "react-router-dom";

import { CommonButton } from "../ui/buttons/CommonButton";

import styles from "./styles/legal.module.css";

export const CommunityRules = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <article className={styles.terms}>
      <CommonButton onClick={handleBack} text="Повернутися назад" />

      <h1>Правила спільноти</h1>

      <section>
        <h2>1. Загальні положення</h2>
        <p>
          Використовуючи коментарі, форуми та інші інтерактивні інструменти
          платформи, ви погоджуєтеся дотримуватися цих правил спільноти.
        </p>
      </section>

      <section>
        <h2>2. Поважлива та конструктивна поведінка</h2>
        <p>
          Користувачі повинні дотримуватися етичних норм: не розповсюджувати
          образливий, дискримінаційний або незаконний контент. Коментарі мають
          бути конструктивними, пов’язаними з навчальним матеріалом, і сприяти
          обговоренню та навчанню.
        </p>
      </section>

      <section>
        <h2>3. Пошук інформації перед запитанням</h2>
        <p>
          Перед тим як задавати запитання в коментарях або на форумах,
          рекомендується спробувати знайти відповідь самостійно:
          <ul>
            <li>переглянути курс або лекційні матеріали;</li>
            <li>перевірити документацію чи ресурси, надані платформою;</li>
            <li>
              використати загальні пошукові ресурси для уточнення термінів чи
              концепцій.
            </li>
          </ul>
          Це допомагає підтримувати високу якість обговорень і швидке навчання
          всіх учасників.
        </p>
      </section>

      <section>
        <h2>4. Заборона спаму та самореклами</h2>
        <p>
          Забороняється розміщувати спам, рекламу сторонніх ресурсів або
          посилання на особисті проєкти без дозволу адміністрації.
        </p>
      </section>

      <section>
        <h2>5. Модерація та блокування</h2>
        <p>
          Порушення цих правил може призвести до видалення коментарів,
          тимчасового або постійного блокування акаунту. Рішення про модерацію
          приймається адміністрацією платформи без попереднього повідомлення.
        </p>
      </section>

      <section>
        <h2>6. Контактна інформація</h2>
        <p>
          Якщо у вас є питання щодо правил спільноти або ви хочете повідомити
          про порушення, зв&apos;яжіться з адміністрацією через доступні на
          сайті канали.
        </p>
      </section>

      <CommonButton onClick={handleBack} text="Повернутися назад" />
    </article>
  );
};
